const DEFAULT_DATA = {
  columns: 4,
  showTabs: false,
  pagination: "infinite",
  collectionId: [],
  maxNumberOfItems: 4,
  borderRadius: 8,
  titleFieldId: "",
};

export const UPCOMING_BIRTHDAYS_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "card",
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    view: "list",
  },
];

export const buildTemplate = (view, borderRadius) => ({
  ...DEFAULT_DATA,
  view,
  borderRadius,
});
